export default __webpack_public_path__ + "static/media/autarq-mobile.fb83dcda.png";